import { EmptyState, Text } from '@shopify/polaris';

export const AuthError = () => {
  return (
    <EmptyState
      heading='Unable to authenticate'
      image='https://cdn.shopify.com/s/files/1/0262/4071/2726/files/emptystate-files.png'
    >
      <Text variant="bodyMd" as="p" color="subdued">
        The system was not able to authenticate you. <br />
        Please try to re-open the app.
      </Text>
    </EmptyState>
  );
};
